module.exports = __webpack_public_path__ + "static/media/botSettings.2895aa46.png";